import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeStatusObjectsComponent from 'webapp/components/infolayer/type-status-objects';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase from 'webapp/models-custom/infolayer-item/base';
import StatusObject from 'webapp/models-custom/status-object';

export interface ConstructorData extends BaseConstructorData {
	statusObjects: StatusObject[];
}

export default class InfolayerItemStatusObjects extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeStatusObjectsComponent;

	statusObjects: StatusObject[];

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.statusObjects = data.statusObjects;
	}

	get isAnyStatusObjectRed() {
		return (this.statusObjects || []).some((so) => {
			return so.statusIconColor === 'red';
		});
	}

	override get classes(): string {
		const extraClass = this.isAnyStatusObjectRed ? 'error' : 'warning';
		return `${super.classes} ${extraClass}`;
	}

	get statusObjectsJQueryElement() {
		return StatusObject.getDataErrorText(this.statusObjects);
	}

	checkIfDuplicated(_items: InfolayerItemBase[]): boolean {
		// Duplicated status objects have already been filtered out in the Infolayer service before being added to the stack
		return false;
	}
}
